import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TeamAdmin } from '@byscott-io/corebyscott';
import DietaryProtocolTab from '../components/admin/DietaryProtocolTab';

const tabs = [
  { id: 'team', label: 'Team' },
  { id: 'categories', label: 'Categories' },
  { id: 'diet', label: 'Diet' },
];

export default function AdminPage() {
  const { tab = 'team' } = useParams();
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Admin</h1>

      {/* Tabs */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="flex gap-4">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => navigate(`/app/admin/${t.id}`)}
              className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
                tab === t.id
                  ? 'border-indigo-600 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {tab === 'team' && <TeamAdmin />}
      {tab === 'categories' && <CategoriesTab />}
      {tab === 'diet' && <DietaryProtocolTab />}
    </div>
  );
}

function CategoriesTab() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <p className="text-gray-500 dark:text-gray-400">
        Category management coming soon. You'll be able to create, edit, and delete recipe categories.
      </p>
    </div>
  );
}
